<script>
import {FormWizard, TabContent} from "vue3-form-wizard";
import VueTimepicker from 'vue3-timepicker'

import "vue3-form-wizard/dist/style.css";
import 'vue3-timepicker/dist/VueTimepicker.css'

import {useVuelidate} from '@vuelidate/core'
import {helpers, required, requiredIf} from '@vuelidate/validators'


import safeScoreSelector from "@/components/subcomponents/safeScoreSelector.vue";
import coPaymentInputs from "@/components/subcomponents/coPaymentInputs.vue";
import dropZone2Component from "@/components/subcomponents/dropZone2Component.vue";


export default {
  inject: ['$Q', '$DateTime', '$axios', '$_'],
  props: {
    'profileID': String,
    'processFrom': String
  },
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    let vm = this;
    return {
      updateNumber: 0,
      validationHasOccured: false,
      draftResp: false,
      feedbackSubmitted: false,
      feedbackSubmittedMsg: '',
      leavingTab: 0,
      enteringTab: 0,
      summaryFeedback: {},
      patientFeedback: {
        profileTS: vm.$_.split(vm.profileID, '-')[1],
        profileIdentifier: vm.profileID,
        surgeryStatus: '',
        surgeryStatusReason: '',
        timeRequired: false,
        surgeryInformation: {
          admissionDate: '',
          admissionTime: {},
          surgeryDate: '',
          surgeryTime: {},
          dischargeDate: '',
          dischargeTime: {},
          surgeryPerformed: '',
          isCoPaying: false,
          coPaymentOOPCurrency: 'USD',
          coPaymentOOPAmount: '',
          coPaymentInsCurrency: 'USD',
          coPaymentInsAmount: '',
          insuranceProvider: '',
          totalCostCurrency: 'USD',
          totalCostAmount: '',
          safeScore: {rating: '', comment: ''},
          gravidity: '',
          parity: '',
          childrenCount: 0,
          childrenData: [],
          patientQuote: '',
          patientStory: ''
        },
        confirmation: {
          faceOne: '',
          faceTwo: '',
          conditionOne: '',
          conditionTwo: '',
          safeScaleReport: '',
          copaymentReceipts: '',
          feedbackAttachment_1: '',
          feedbackAttachment_2: '',
          feedbackAttachment_3: '',
          signedAcknowledgement: ''
        },
        dropzone2Trigger: ''
      },
      historicalDateConfig: {
        disabledDates: {}
      },
      showErrors: [false, false, false],
      activeProfile: {},
      surgeriesReturned: [],
      surgeryPicked: [true],
      surgerySearchStatus: [false],
      surgeryHasGravidity: [false],
      surgeryHasParity: [false],
      safeScoreText: 'Give a brief summary of the reason for the SAFE Scale Score. How will the surgical outcome impact the patient’s life? If the treatment was not a success, please describe what happened, and let us know if there are any next steps',
      GPSExifLocationKeys: ['GPSLatitudeRef', 'GPSLatitude',
        'GPSLongitudeRef', 'GPSLongitude'],
      GPSExifKeys: [
        'GPSVersionID', 'GPSLatitudeRef', 'GPSLatitude',
        'GPSLongitudeRef', 'GPSLongitude', 'GPSAltitudeRef',
        'GPSAltitude', 'GPSTimeStamp', 'GPSSatellites',
        'GPSStatus', 'GPSMeasureMode', 'GPSDOP',
        'GPSSpeedRef', 'GPSSpeed', 'GPSTrackRef',
        'GPSTrack', 'GPSImgDirectionRef', 'GPSImgDirection',
        'GPSMapDatum', 'GPSDestLatitudeRef', 'GPSDestLatitude',
        'GPSDestLongitudeRef', 'GPSDestLongitude', 'GPSDestBearingRef',
        'GPSDestBearing', 'GPSDestDistanceRef', 'GPSDestDistance',
        'GPSProcessingMethod', 'GPSAreaInformation', 'GPSDateStamp',
        'GPSDifferential', 'GPSHPositioningError', 'GPSInfoIFDPointer'],
      DateTimeExifKeys: ['DateTime', 'DateTimeOriginal', 'DateTimeDigitized'],
      trueBool: true,
      currentData: {},
      parityInProfile: true,
      gravidityInProfile: true,
    }
  },
  validations() {
    let vm = this;
    return {
      patientFeedback: {
        surgeryStatus: {required: helpers.withMessage("{Surgery Tab} Please provide the surgery status", required)},
        surgeryStatusReason: {requiredIfSurgeryNotDone: helpers.withMessage(" {Surgery Tab} Please provide the reason for the surgery status", requiredIf(vm.patientFeedback.surgeryStatus === 'surgeryStatusPull' || vm.patientFeedback.surgeryStatus === 'surgeryStatusCancelled'))},
        surgeryInformation: {
          admissionDate: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the admission date", requiredIf(vm.surgeryHappened))},
          surgeryDate: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the surgery date", requiredIf(vm.surgeryHappened))},
          dischargeDate: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the discharge date", requiredIf(vm.surgeryHappened))},
          admissionTime: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the admission time", requiredIf(vm.surgeryHappened && vm.isABirthSurgery))},
          surgeryTime: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the surgery time", requiredIf(vm.surgeryHappened && vm.isABirthSurgery))},
          dischargeTime: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the discharge time", requiredIf(vm.surgeryHappened && vm.isABirthSurgery))},
          surgeryPerformed: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the actual surgery performed", requiredIf(vm.surgeryHappened))},
          totalCostAmount: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the total amount", requiredIf(vm.surgeryHappened))},
          coPaymentOOPAmount: {requiredIfCopaySelectedAndOOPEmpty: helpers.withMessage("{Surgery Tab} Please specify the co-payment amount", requiredIf(vm.surgeryHappened && vm.copaymentRequired))},
          coPaymentInsAmount: {requiredIfCopaySelectedAndInsEmpty: helpers.withMessage("{Surgery Tab} Please specify the co-payment amount", requiredIf(vm.surgeryHappened && vm.copaymentRequired))},
          insuranceProvider: {requiredIfInsuranceCopay: helpers.withMessage("{Surgery Tab} Please specify the insurance provider", requiredIf(vm.surgeryHappened && vm.patientFeedback.surgeryInformation.coPaymentInsAmount > 0))},
          safeScore: {
            rating: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the rating for the safe score", requiredIf(vm.surgeryHappened))},
            comment: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the comment for the safe score", requiredIf(vm.surgeryHappened))}
          },
          gravidity: {
            requiredIfIsABirthSurgery: helpers.withMessage("{Surgery Tab} Please provide the gravidity", requiredIf(vm.surgeryHappened && vm.isABirthSurgery))
          },
          parity: {
            requiredIfIsABirthSurgery: helpers.withMessage("{Surgery Tab} Please provide the total parity", requiredIf(vm.surgeryHappened && vm.isABirthSurgery))
          },
          childrenCount: {
            requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the number or children", requiredIf(vm.surgeryHappened && vm.isABirthSurgery))
          },
          patientQuote: {requiredIfSurgeryHappenedAndPatientAlive: helpers.withMessage("{Surgery Tab} Please provide the patient quote", requiredIf(vm.surgeryHappened && vm.patientIsAlive))},
          patientStory: {requiredIfSurgeryHappened: helpers.withMessage("{Surgery Tab} Please provide the patient story", requiredIf(vm.surgeryHappened))},
        },
        confirmation: {
          faceOne: {requiredIfSurgeryHappenedAndPatientAlive: helpers.withMessage("{Attachments Tab} Please provide the 1st photo of the patient's face", requiredIf(vm.surgeryHappened && vm.patientIsAlive))},
          faceTwo: {requiredIfSurgeryHappenedAndPatientAlive: helpers.withMessage("{Attachments Tab} Please provide the 2nd photo of the patient's face", requiredIf(vm.surgeryHappened && vm.patientIsAlive))},
          safeScaleReport: {requiredIfSurgeryHappened: helpers.withMessage("{Attachments Tab} Please provide the safe scale doctor's report", requiredIf(vm.surgeryHappened))},
          signedAcknowledgement: {required: helpers.withMessage("{Attachments Tab} Please select if you commit to acknowledge the information is true", required)},
        }
      }
    };
  },
  components: {
    dropZone2Component,
    coPaymentInputs,
    FormWizard,
    TabContent,
    VueTimepicker,
    safeScoreSelector
  },
  methods: {
    IntegersOnly(event) {
      let charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 8 || charCode === 127) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    FloatsOnly(event) {
      let charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 8 || charCode === 127 || charCode === 190) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    noNegativeValues(numberProvidedField, errorValue) {
      let vm = this,
          numberProvided
      switch (numberProvidedField) {
        case 'totalCostAmount':
          numberProvided = vm.patientFeedback.surgeryInformation.totalCostAmount;
          break;
        case 'gravidity':
          numberProvided = vm.patientFeedback.surgeryInformation.gravidity;
          break;
        case 'parity':
          numberProvided = vm.patientFeedback.surgeryInformation.parity;
          break;
        case 'childrenCount':
          numberProvided = vm.patientFeedback.surgeryInformation.childrenCount;
          break;
      }
      const numberProvidedRounded = Math.round(Number(numberProvided))
      let numberProvidedRoundedAccepted = numberProvidedRounded
      if (numberProvidedRounded <= 0) {
        numberProvidedRoundedAccepted = errorValue
      }
      switch (numberProvidedField) {
        case 'totalCostAmount':
          vm.patientFeedback.surgeryInformation.totalCostAmount = numberProvidedRoundedAccepted;
          break;
        case 'gravidity':
          vm.patientFeedback.surgeryInformation.gravidity = numberProvidedRoundedAccepted;
          break;
        case 'parity':
          vm.patientFeedback.surgeryInformation.parity = numberProvidedRoundedAccepted;
          break;
        case 'childrenCount':
          vm.patientFeedback.surgeryInformation.childrenCount = numberProvidedRoundedAccepted;
          if (vm.activeProfile.parity !== '-') {
            vm.patientFeedback.surgeryInformation.parity = parseInt(vm.activeProfile.parity) + parseInt(numberProvidedRoundedAccepted);
          }
          break;
      }
    },
    inReturnedFeedbacks: async function () {
      let vm = this;
      let returnedFeedbackPatient = await vm.getPatientFromDb(vm.IDB, 'returnedFeedbacks', vm.profileID, 'caseId', false);
      return typeof returnedFeedbackPatient !== 'undefined';
    },
    admissionDateSelected() {

    },
    surgeryDateSelected() {

    },
    dischargeDateSelected() {

    },
    resize(textAreaRef) {
      let vm = this;
      let element = vm.$refs[textAreaRef];
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    },
    resizeById(textAreaId) {
      let element = document.getElementById(textAreaId);
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    },
    postDraftFeedback() {
      let vm = this;
      try {
        vm.$axios
            .post('/profile/action/updateDraftFeedback', {
              draftFeedback: vm.patientFeedback,
              repData: vm.currentData,
              updateNumber: vm.updateNumber++,
              returnedFeedback: vm.inReturnedFeedbacks()
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              if (response.data.success) {
                if ((response.data.updateNumber + 1) === vm.updateNumber) {
                  vm.patientFeedback = response.data.patientFeedback;
                  vm.summaryFeedback = response.data.summaryJson;
                  vm.draftResp = true;
                }
              }
            })
      } catch (error) {
        console.error(error);
      }
    },
    closeFeedbackForm: function () {
      let vm = this;
      vm.$emit('feedbackSaved', {});
    },
    onComplete() {
      let vm = this;
      if (vm.v$.$errors.length === 0) {
        const wizardButtons = document.querySelectorAll(".wizard-btn");
        vm.$_.forEach(wizardButtons, function (wizardButton) {
          wizardButton.disabled = true;
        });
        try {
          vm.$axios
              .post('/profile/action/submitDraftFeedback', {
                draftFeedback: vm.patientFeedback,
                repData: vm.currentData,
                returnedFeedback: vm.inReturnedFeedbacks()
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${vm.currentData.token}`
                }
              })
              .then(function (response) {
                vm.feedbackSubmitted = response.data.success;
                if (response.data.success) {
                  vm.feedbackSubmittedMsg = response.data.msg;
                } else {
                  vm.$_.forEach(wizardButtons, function (wizardButton) {
                    wizardButton.disabled = false;
                  });
                }
              })
        } catch (error) {
          console.error(error);
          vm.$_.forEach(wizardButtons, function (wizardButton) {
            wizardButton.disabled = false;
          });
        }
      }
    },
    async validateForm() {
      const vm = this;
      await this.v$.$validate();
      vm.validationHasOccured = true;
    },
    onTabChange(prevIndex, nextIndex) {
      let vm = this;
      vm.leavingTab = prevIndex;
      vm.enteringTab = nextIndex;

      if (prevIndex === 0) {
        vm.showErrors[0] = true;
        vm.postDraftFeedback()
      }

      if (prevIndex === 1) {
        vm.showErrors[1] = true;
      }

      vm.validateForm();

      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    },
    coPaymentDataValReceived(emittedObj) {
      let vm = this;
      vm.patientFeedback.surgeryInformation.coPaymentOOPCurrency = emittedObj.coPaymentOOPCurrency;
      vm.patientFeedback.surgeryInformation.coPaymentOOPAmount = emittedObj.coPaymentOOPAmount;
      vm.patientFeedback.surgeryInformation.coPaymentInsCurrency = emittedObj.coPaymentInsCurrency;
      vm.patientFeedback.surgeryInformation.coPaymentInsAmount = emittedObj.coPaymentInsAmount;
      vm.patientFeedback.surgeryInformation.insuranceProvider = emittedObj.insuranceProvider;

    },
    safeScoreValReceived(emittedObj) {
      let vm = this;
      vm.patientFeedback.surgeryInformation.safeScore.rating = emittedObj.rating;
      vm.patientFeedback.surgeryInformation.safeScore.comment = emittedObj.comment;
    },
    dropZone2Emissions(dropZone2Emission) {
      let vm = this;
      vm.patientFeedback.dropzone2Trigger = `${dropZone2Emission.action}@${vm.$DateTime.local().setZone(vm.currentData.country_tz).toUnixInteger()}`;

      if (dropZone2Emission.action === 'imageRemoved') {
        vm.patientFeedback.confirmation[dropZone2Emission.fileIdentifier] = '';
      }

    },
    displayErrorsForTab(tabName) {
      let vm = this,
          returnedErrors = [],
          errorParts = [],
          tabsErrorShow = {"Surgery Tab": 0, "Attachments Tab": 1};
      vm.$_.forEach(vm.v$.$errors, function (error) {
        if (error.$message.toString().indexOf(tabName) === 1 && vm.showErrors[tabsErrorShow[tabName]]) {
          errorParts = vm.$_.split(error.$message, '}');
          returnedErrors.push({uid: error.$uid, message: errorParts[1]});
        }
      });
      return returnedErrors;
    },
  },
  computed: {
    setDatePickerClassDob: function () {
      let vm = this;
      try {
        if (vm.v$.patientFeedback.surgeryInformation.admissionDate.$errors.length > 0 && vm.showErrors[0]) {
          return 'wrapper-custom input error-input';
        } else {
          return 'wrapper-custom input';
        }
      } catch (error) {
        return 'wrapper-custom input';
      }
    },
    isABirthSurgery: function () {
      let vm = this,
          returnVal;
      returnVal = vm.patientFeedback.timeRequired;
      if (!returnVal) {
        vm.patientFeedback.surgeryInformation.gravidity = '';
        vm.patientFeedback.surgeryInformation.parity = '';
        vm.patientFeedback.surgeryInformation.childrenCount = '';
      }

      return returnVal;
    },
    returnAdmissionTimeClass: function () {
      let vm = this;
      if (vm.$_.isEmpty(vm.patientFeedback.surgeryInformation.admissionTime) && vm.showErrors[0]) {
        return 'input input-no-top-margin error-input';
      } else {
        return 'input input-no-top-margin';
      }
    },
    returnSurgeryTimeClass: function () {
      let vm = this;
      if (vm.$_.isEmpty(vm.patientFeedback.surgeryInformation.surgeryTime) && vm.showErrors[0]) {
        return 'input input-no-top-margin error-input';
      } else {
        return 'input input-no-top-margin';
      }
    },
    returnDischargeTimeClass: function () {
      let vm = this;
      if (vm.$_.isEmpty(vm.patientFeedback.surgeryInformation.dischargeTime) && vm.showErrors[0]) {
        return 'input input-no-top-margin error-input';
      } else {
        return 'input input-no-top-margin';
      }
    },
    showChildrenSection: function () {
      let vm = this;
      return Number.isInteger(vm.patientFeedback.surgeryInformation.childrenCount) && parseInt(vm.patientFeedback.surgeryInformation.childrenCount) > 0;
    },
    validSafeScoreRating: function () {
      let vm = this;
      return vm.patientFeedback.surgeryInformation.safeScore.rating >= 1;
    },
    returnSafeScoreData() {
      let vm = this;
      return {
        rating: vm.patientFeedback.surgeryInformation.safeScore.rating,
        comment: vm.patientFeedback.surgeryInformation.safeScore.comment
      }
    },
    returnCopaymentDataObj() {
      let vm = this;
      return {
        coPaymentOOPCurrency: vm.patientFeedback.surgeryInformation.coPaymentOOPCurrency,
        coPaymentOOPAmount: vm.patientFeedback.surgeryInformation.coPaymentOOPAmount,
        coPaymentInsCurrency: vm.patientFeedback.surgeryInformation.coPaymentInsCurrency,
        coPaymentInsAmount: vm.patientFeedback.surgeryInformation.coPaymentInsAmount,
        insuranceProvider: vm.patientFeedback.surgeryInformation.insuranceProvider,
      }
    },
    copaymentRequired() {
      let vm = this,
          copaymentRequiredBool = false;
      if (vm.patientFeedback.surgeryInformation.isCoPaying) {
        copaymentRequiredBool = parseInt(vm.patientFeedback.surgeryInformation.coPaymentOOPAmount) === 0 && parseInt(vm.patientFeedback.surgeryInformation.coPaymentInsAmount) === 0;
      }

      return copaymentRequiredBool;
    },
    surgeryHappened() {
      let vm = this;
      return vm.patientFeedback.surgeryStatus === 'surgeryStatusDone';
    },
    patientIsAlive() {
      let vm = this;
      return vm.patientFeedback.surgeryInformation.safeScore.rating !== 'V';
    },
    summaryAvailableBool() {
      let vm = this;
      return vm.validationHasOccured && vm.v$.$errors.length <= 0;
    },
    returnSummaryFeedbackData() {
      let vm = this;
      return vm.summaryFeedback;
    },
    parityValue() {
      let vm = this;
      return vm.patientFeedback.surgeryInformation.parity;
    }
  },
  watch: {
    patientFeedback: {
      handler(newValue) {
        let vm = this,
            childObject = {
              name: '',
              apgar1Min: '',
              apgar5Min: '',
              gender: '',
              weight: '',
              birthOutcome: '',
              complication: '',
              complicationDetails: ''
            };

        if ((typeof newValue.surgeryInformation.childrenCount !== 'undefined') &&
            (Number.isInteger(newValue.surgeryInformation.childrenCount)) &&
            (parseInt(newValue.surgeryInformation.childrenCount) !== vm.patientFeedback.surgeryInformation.childrenData.length) &&
            (parseInt(newValue.surgeryInformation.childrenCount) > 0)
        ) {
          if (parseInt(newValue.surgeryInformation.childrenCount) > vm.patientFeedback.surgeryInformation.childrenData.length) {
            vm.patientFeedback.surgeryInformation.childrenData.push(childObject);
          } else {
            vm.patientFeedback.surgeryInformation.childrenData.splice((parseInt(newValue.surgeryInformation.childrenCount) - 1));
          }
        }


        if (vm.draftResp) {
          vm.draftResp = false;
        } else {
          if (vm.$_.trim(vm.patientFeedback.profileTS) !== '' && vm.$_.trim(vm.patientFeedback.surgeryStatus) !== '') {
            vm.postDraftFeedback();
          }
        }


      },
      deep: true
    }
  },
  async mounted() {
    let vm = this,
        storedAccount = localStorage.getItem("account");

    vm.IDB = await vm.getIDB();

    if (typeof vm.profileID !== ''.toString()) {
      vm.currentData = JSON.parse(storedAccount);

      let approvedProfilePatient,
          draftFeedbackPatient,
          returnedFeedbackPatient;
      switch (vm.processFrom) {
        case 'approvedprofiles':

          approvedProfilePatient = await vm.getPatientFromDb(vm.IDB, 'approvedProfiles', vm.profileID, 'caseId', false);

          if (typeof approvedProfilePatient[0] !== 'undefined') {
            vm.activeProfile = approvedProfilePatient[0].caseData;

            if (vm.activeProfile.gravidity === '-') {
              vm.gravidityInProfile = false;
              vm.patientFeedback.surgeryInformation.gravidity = '';
            } else {
              vm.gravidityInProfile = true;
              vm.patientFeedback.surgeryInformation.gravidity = vm.activeProfile.gravidity;
            }

            if (vm.activeProfile.parity === '-') {
              vm.parityInProfile = false;
              vm.patientFeedback.surgeryInformation.parity = '';
            } else {
              vm.parityInProfile = true;
              vm.patientFeedback.surgeryInformation.parity = vm.activeProfile.parity;
            }

            vm.patientFeedback.profileTS = approvedProfilePatient[0].caseData.profileCreationTS;
            vm.$_.forEach(JSON.parse(localStorage.getItem("preapproval")), function (preapprovalItem) {
              if (vm.$_.trim(preapprovalItem.surgery.toString().toLowerCase()) === vm.$_.trim(vm.activeProfile.surgeryRequired.toString().toLowerCase())) {
                if (vm.$_.trim(preapprovalItem.time_required.toString().toLowerCase()) === '1') {
                  vm.patientFeedback.timeRequired = vm.$_.trim(preapprovalItem.time_required.toString().toLowerCase()) === '1';
                }
              }
            });
          }


          break;
        case 'draftfeedbacks':

          draftFeedbackPatient = await vm.getPatientFromDb(vm.IDB, 'draftFeedbacks', vm.profileID, 'caseId', false);

          if (typeof draftFeedbackPatient[0] !== 'undefined') {
            vm.patientFeedback = draftFeedbackPatient[0].caseData.patientFeedback;
            vm.activeProfile = draftFeedbackPatient[0].caseData.profileSummary;

            if (vm.activeProfile.gravidity === '-') {
              vm.gravidityInProfile = false;
              vm.patientFeedback.surgeryInformation.gravidity = '';
            } else {
              vm.gravidityInProfile = true;
              vm.patientFeedback.surgeryInformation.gravidity = vm.activeProfile.gravidity;
            }

            if (vm.activeProfile.parity === '-') {
              vm.parityInProfile = false;
              vm.patientFeedback.surgeryInformation.parity = '';
            } else {
              vm.parityInProfile = true;
              vm.patientFeedback.surgeryInformation.parity = vm.activeProfile.parity;
            }

          }
          break;
        case 'returnedfeedbacks':

          returnedFeedbackPatient = await vm.getPatientFromDb(vm.IDB, 'returnedFeedbacks', vm.profileID, 'caseId', false);

          if (typeof returnedFeedbackPatient[0] !== 'undefined') {
            vm.patientFeedback = returnedFeedbackPatient[0].caseData.patientFeedback;
            vm.activeProfile = returnedFeedbackPatient[0].caseData.profile;

            if (vm.activeProfile.gravidity === '-') {
              vm.gravidityInProfile = false;
              vm.patientFeedback.surgeryInformation.gravidity = '';
            } else {
              vm.gravidityInProfile = true;
              vm.patientFeedback.surgeryInformation.gravidity = vm.activeProfile.gravidity;
            }

            if (vm.activeProfile.parity === '-') {
              vm.parityInProfile = false;
              vm.patientFeedback.surgeryInformation.parity = '';
            } else {
              vm.parityInProfile = true;
              vm.patientFeedback.surgeryInformation.parity = vm.activeProfile.parity;
            }

          }


          break;
      }
    }

  },
};
</script>

<template>
  <div class="profile-form-container" v-if="!feedbackSubmitted">
    <FormWizard @on-complete="onComplete" @on-change="onTabChange" color="#094899" class="" step-size="md">
      <TabContent title="Surgery" icon="fa fa-user-doctor">
        <div class="container">
          <div class="columns is-multiline is-vcentered">
            <div class="column is-full">
              <h1 class="is-size-3 is-underlined">Profile {{ profileID }}</h1>
            </div>
            <div class="column is-full">
              <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Profile Data</div>
                </div>
                <div class="column is-full can-scroll-content">
                  <table class="table is-striped is-fullwidth">
                    <tbody>
                    <tr>
                      <td class="left-side-table-cell" colspan="3">
                        <label class="label has-text-left">Full Name</label>
                        <div class="has-text-centered">{{ activeProfile.patientName }}</div>
                      </td>
                      <td class="right-side-table-cell" colspan="3">
                        <label class="label has-text-left">Patient Hospital Number</label>
                        <div class="has-text-centered">{{ activeProfile.inpatientNumber }}</div>
                      </td>
                    </tr>
                    <tr>
                      <td class="left-side-table-cell" colspan="3">
                        <label class="label has-text-left">Gender</label>
                        <div class="has-text-centered">{{ activeProfile.patientGender }}</div>
                      </td>
                      <td class="right-side-table-cell" colspan="3">
                        <label class="label has-text-left">Date of Birth</label>
                        <div class="has-text-centered">{{ activeProfile.patientDob }}</div>
                      </td>
                    </tr>
                    <tr>
                      <td class="left-side-table-cell" colspan="2">
                        <label class="label has-text-left">Type</label>
                        <div class="has-text-centered">{{ activeProfile.surgeryType }}</div>
                      </td>
                      <td class="middle-table-cell" colspan="2">
                        <label class="label has-text-left">Surgery required</label>
                        <div class="has-text-centered">{{ activeProfile.surgeryRequired }}</div>
                      </td>
                      <td class="right-side-table-cell" colspan="2">
                        <label class="label has-text-left">Estimated Date of Surgery</label>
                        <div class="has-text-centered">{{ activeProfile.estimatedSurgeryDay }}</div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="surgeryStatus" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Surgery Status</div>
                </div>
                <div class="column is-full has-text-left">
                  <label class="label has-text-centered">Surgery Status</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered"
                           v-bind:class="{'error-input':v$.patientFeedback.surgeryStatus.$errors.length>0 && showErrors[0]}">
                        <input v-bind:disabled="inputsDisabled" type="radio" name="surgeryStatus" id="surgeryStatusDone"
                               value="surgeryStatusDone"
                               class="fancy-input"
                               v-model="patientFeedback.surgeryStatus"/>
                        <label for="surgeryStatusDone" class="fancy-input-label column no-wrapping-label">Done</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="surgeryStatus" id="surgeryStatusPull"
                               value="surgeryStatusPull"
                               class="fancy-input" v-model="patientFeedback.surgeryStatus"/>
                        <label for="surgeryStatusPull" class="fancy-input-label column no-wrapping-label">Pull</label>
                        <input v-bind:disabled="inputsDisabled" type="radio" name="surgeryStatus"
                               id="surgeryStatusCancelled"
                               value="surgeryStatusCancelled"
                               class="fancy-input" v-model="patientFeedback.surgeryStatus"/>
                        <label for="surgeryStatusCancelled"
                               class="fancy-input-label column no-wrapping-label">Cancelled</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>

                <div class="column is-full has-text-left label-no-padding-bottom"
                     v-if="patientFeedback.surgeryStatus === 'surgeryStatusPull' || patientFeedback.surgeryStatus === 'surgeryStatusCancelled'">
                  <label class="label has-text-centered">Reason</label>
                  <textarea class="textarea" placeholder="Actual Surgery done"
                            v-bind:class="{'error-input':v$.patientFeedback.surgeryStatusReason.$errors.length>0 && showErrors[0]}"
                            v-model="patientFeedback.surgeryStatusReason"
                  ></textarea>
                </div>
                <div class="column is-full"
                     v-if="patientFeedback.surgeryStatus === 'surgeryStatusPull' || patientFeedback.surgeryStatus === 'surgeryStatusCancelled'"></div>

              </div>
            </div>

            <div class="column is-full" v-if="surgeryHappened">
              <h1 class="is-size-3 is-underlined">Surgery Information</h1>
            </div>

            <div class="column is-full" v-if="surgeryHappened">
              <div id="surgeryTwo" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Key Dates</div>
                </div>

                <div class="column is-one-third">
                  <div class="columns is-multiline">
                    <div class="column is-full">
                      <label class="label has-text-centered">Admission</label>
                    </div>
                    <div class="column is-full has-text-left label-no-padding-bottom">
                      <label class="has-text-left">Date</label>
                      <div class="field">
                        <p class="control is-expanded">
                          <datepicker v-model="patientFeedback.surgeryInformation.admissionDate"
                                      name="patientadmissiondate"
                                      v-bind:disabled-dates="historicalDateConfig.disabledDates"
                                      v-bind:clear-button="true"
                                      v-bind:input-class="'input-custom'"
                                      v-bind:wrapper-class="setDatePickerClassDob"
                                      v-bind:calendar-class="'calendar-custom'"
                                      v-on:selected="admissionDateSelected"></datepicker>
                        </p>
                      </div>
                    </div>
                    <div class="column is-full has-text-left label-no-padding-bottom"
                         v-if="patientFeedback.timeRequired">
                      <label class="has-text-left">Time</label>
                      <div class="field">
                        <p class="control is-expanded">
                          <VueTimepicker v-bind:input-class="returnAdmissionTimeClass"
                                         v-model="patientFeedback.surgeryInformation.admissionTime"
                                         close-on-complete></VueTimepicker>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-one-third surgery-date-time">
                  <div class="columns is-multiline">
                    <div class="column is-full">
                      <label class="label has-text-centered">Surgery</label>
                    </div>
                    <div class="column is-full has-text-left label-no-padding-bottom">
                      <label class="has-text-left">Date</label>
                      <div class="field">
                        <p class="control is-expanded">
                          <datepicker v-model="patientFeedback.surgeryInformation.surgeryDate"
                                      name="patientadmissiondate"
                                      v-bind:disabled-dates="historicalDateConfig.disabledDates"
                                      v-bind:clear-button="true"
                                      v-bind:input-class="'input-custom'"
                                      v-bind:wrapper-class="setDatePickerClassDob"
                                      v-bind:calendar-class="'calendar-custom'"
                                      v-on:selected="surgeryDateSelected"></datepicker>
                        </p>
                      </div>
                    </div>
                    <div class="column is-full has-text-left label-no-padding-bottom"
                         v-if="patientFeedback.timeRequired">
                      <label class="has-text-left">Time</label>
                      <div class="field">
                        <p class="control is-expanded">
                          <VueTimepicker v-bind:input-class="returnSurgeryTimeClass"
                                         v-model="patientFeedback.surgeryInformation.surgeryTime"
                                         close-on-complete></VueTimepicker>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-one-third">
                  <div class="columns is-multiline">
                    <div class="column is-full">
                      <label class="label has-text-centered">Discharge</label>
                    </div>
                    <div class="column is-full has-text-left label-no-padding-bottom">
                      <label class="has-text-left">Date</label>
                      <div class="field">
                        <p class="control is-expanded">
                          <datepicker v-model="patientFeedback.surgeryInformation.dischargeDate"
                                      name="patientadmissiondate"
                                      v-bind:disabled-dates="historicalDateConfig.disabledDates"
                                      v-bind:clear-button="true"
                                      v-bind:input-class="'input-custom'"
                                      v-bind:wrapper-class="setDatePickerClassDob"
                                      v-bind:calendar-class="'calendar-custom'"
                                      v-on:selected="dischargeDateSelected"></datepicker>
                        </p>
                      </div>
                    </div>
                    <div class="column is-full has-text-left label-no-padding-bottom"
                         v-if="patientFeedback.timeRequired">
                      <label class="has-text-left">Time</label>
                      <div class="field">
                        <p class="control is-expanded">
                          <VueTimepicker v-bind:input-class="returnDischargeTimeClass"
                                         v-model="patientFeedback.surgeryInformation.dischargeTime"
                                         close-on-complete></VueTimepicker>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>

            <div class="column is-full" v-if="surgeryHappened"></div>
            <div class="column is-full" v-if="surgeryHappened">
              <div id="surgeryFive" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Surgery Details</div>
                </div>
                <div class="column is-full can-scroll-content">
                  <table class="table is-striped is-fullwidth">
                    <tbody>
                    <tr>
                      <td class="left-side-table-cell" colspan="2">
                        <label class="label has-text-left">Surgery requested</label>
                        <div class="has-text-centered">{{ activeProfile.surgeryRequired }}</div>
                      </td>
                      <td class="middle-table-cell" colspan="2">
                        <label class="label has-text-left">Safe Ask</label>
                        <div class="has-text-centered">{{ activeProfile.safeAskAmount }}</div>
                      </td>
                      <td class="right-side-table-cell" colspan="2">
                        <label class="label has-text-left">Co-Payment Amount</label>
                        <div class="has-text-centered">{{ activeProfile.copaymentAmount }}</div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div class="column is-full has-text-left label-no-padding-bottom">
                  <label class="label has-text-centered">Actual Surgery done</label>
                  <textarea class="textarea" placeholder="Actual Surgery done"
                            v-bind:class="{'error-input':v$.patientFeedback.surgeryInformation.totalCostAmount.$errors.length>0 && showErrors[0]}"
                            v-model="patientFeedback.surgeryInformation.surgeryPerformed"
                  ></textarea>
                </div>


                <div class="column is-half has-text-left label-no-padding-bottom">
                  <label class="label has-text-centered">Final Bill</label>
                  <div class="field has-addons">
                    <p class="control">
                <span class="select">
                  <select v-model="patientFeedback.surgeryInformation.totalCostCurrency">
                    <option value="USD">USD</option>
                    <option value="KES">KES</option>
                    <option value="UGX">UGX</option>
                    <option value="TSH">TSH</option>
                    <option value="ETB">ETB</option>
                    <option value="MWK">MWK</option>
                  </select>
                </span>
                    </p>
                    <p class="control is-expanded">
                      <input class="input input-no-margin-top" type="text" placeholder="Total Cost Amount"
                             v-bind:class="{'error-input':v$.patientFeedback.surgeryInformation.totalCostAmount.$errors.length>0 && showErrors[0]}"
                             v-model="patientFeedback.surgeryInformation.totalCostAmount"
                             v-on:keydown="IntegersOnly"
                             v-on:change="noNegativeValues('totalCostAmount','')">
                    </p>
                  </div>
                </div>
                <div class="column is-half has-text-left label-no-padding-bottom">
                  <label class="label has-text-centered">&nbsp;</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered">
                        <input v-bind:disabled="inputsDisabled" type="checkbox" name="patientiscopaying"
                               id="patientiscopaying"
                               class="fancy-input" v-model="patientFeedback.surgeryInformation.isCoPaying"/>
                        <label for="patientiscopaying"
                               class="fancy-input-label column no-wrapping-label">Co-paying</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>

                <coPaymentInputs
                    v-if="patientFeedback.surgeryInformation.isCoPaying"
                    v-bind:coPaymentData="returnCopaymentDataObj"
                    v-bind:insuranceProviderError="v$.patientFeedback.surgeryInformation.insuranceProvider.$errors.length>0 && showErrors[0]"
                    v-bind:OOPAmountError="copaymentRequired && showErrors[0]"
                    v-bind:InsAmountError="copaymentRequired && showErrors[0]"
                    v-bind:inputsDisabled="false"
                    v-on:coPaymentDataVal="coPaymentDataValReceived"
                ></coPaymentInputs>

                <div class="column is-full has-text-left label-no-padding-bottom">
                  <safeScoreSelector
                      v-bind:inputsDisabled="false"
                      v-bind:safeScoreRatingError="v$.patientFeedback.surgeryInformation.safeScore.rating.$errors.length>0 && showErrors[0]"
                      v-bind:safeScoreCommentError="v$.patientFeedback.surgeryInformation.safeScore.comment.$errors.length>0 && showErrors[0]"
                      v-bind:safeScoreData="returnSafeScoreData"
                      v-on:safeScoreVal="safeScoreValReceived"
                  >
                  </safeScoreSelector>
                </div>
                <div class="column is-full"></div>

              </div>
            </div>

            <div class="column is-full" v-if="isABirthSurgery && surgeryHappened"></div>
            <div class="column is-full" v-if="isABirthSurgery && surgeryHappened">
              <div id="surgerySix" class="columns is-multiline  is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Birth Outcome Details</div>
                </div>

                <div class="column is-one-third has-text-left label-no-padding-bottom">
                  <label class="label has-text-centered">Gravidity</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder="Gravidity" readonly disabled
                             v-bind:class="{'error-input':v$.patientFeedback.surgeryInformation.gravidity.$errors.length>0 && showErrors[0]}"
                             v-model="patientFeedback.surgeryInformation.gravidity"
                             v-on:keydown="IntegersOnly"
                             v-on:change="noNegativeValues('gravidity','')"
                             v-if="gravidityInProfile">
                      <input class="input input-no-top-margin" type="text" placeholder="Gravidity"
                             v-bind:class="{'error-input':v$.patientFeedback.surgeryInformation.gravidity.$errors.length>0 && showErrors[0]}"
                             v-model="patientFeedback.surgeryInformation.gravidity"
                             v-on:keydown="IntegersOnly"
                             v-on:change="noNegativeValues('gravidity','')"
                             v-else>
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'person-pregnant']"/>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-one-third has-text-left label-no-padding-bottom">
                  <label class="label has-text-centered">Children Born</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder="Children born"
                             v-bind:class="{'error-input':v$.patientFeedback.surgeryInformation.childrenCount.$errors.length>0 && showErrors[0]}"
                             v-model="patientFeedback.surgeryInformation.childrenCount"
                             v-on:keydown="IntegersOnly"
                             v-on:keyup="noNegativeValues('childrenCount','')">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'baby-carriage']"/>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-one-third has-text-left label-no-padding-bottom">
                  <label class="label has-text-centered">New Parity</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder="Parity" readonly disabled
                             v-bind:class="{'error-input':v$.patientFeedback.surgeryInformation.parity.$errors.length>0 && showErrors[0]}"
                             v-model="parityValue"
                             v-on:keydown="IntegersOnly"
                             v-on:change="noNegativeValues('parity','')"
                             v-if="parityInProfile">
                      <input class="input input-no-top-margin" type="text" placeholder="Parity"
                             v-bind:class="{'error-input':v$.patientFeedback.surgeryInformation.parity.$errors.length>0 && showErrors[0]}"
                             v-model="patientFeedback.surgeryInformation.parity"
                             v-on:keydown="IntegersOnly"
                             v-on:change="noNegativeValues('parity','')"
                             v-else>
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'baby']"/>
                </span>
                    </p>
                  </div>
                </div>

              </div>
            </div>

            <div class="column is-full" v-if="showChildrenSection && surgeryHappened"></div>
            <div class="column is-full" v-if="showChildrenSection && surgeryHappened"></div>
            <div class="container" v-if="showChildrenSection && surgeryHappened">
              <div v-for="(child, index) in patientFeedback.surgeryInformation.childrenData"
                   v-bind:id="`surgerySeven_${index}`"
                   class="columns is-multiline is-vcentered section-box child-box"
                   v-bind:key="index">

                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Child {{ index + 1 }}: {{ child.name }}</div>
                </div>

                <div class="column is-full has-text-left bottom-border-input"
                     v-bind:class="{'bottom-border-input-mobile':patientFeedback.surgeryInformation.childrenData[index].complication===`birthComplicationChild_${index}_birthcomplication` || patientFeedback.surgeryInformation.childrenData[index].birthOutcome===`birthOutcomeChild_${index}_alive`}">
                  <label class="label has-text-centered">Birth Outcome</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered">
                        <input type="radio" v-bind:name="`birthOutcomeChild_${index}`"
                               v-bind:id="`birthOutcomeChild_${index}_alive`"
                               v-bind:value="`birthOutcomeChild_${index}_alive`"
                               class="fancy-input"
                               v-model="patientFeedback.surgeryInformation.childrenData[index].birthOutcome"/>
                        <label v-bind:for="`birthOutcomeChild_${index}_alive`"
                               class="fancy-input-label column no-wrapping-label">Alive</label>

                        <input type="radio" v-bind:name="`birthOutcomeChild_${index}`"
                               v-bind:id="`birthOutcomeChild_${index}_still`"
                               v-bind:value="`birthOutcomeChild_${index}_still`"
                               class="fancy-input"
                               v-model="patientFeedback.surgeryInformation.childrenData[index].birthOutcome"/>
                        <label v-bind:for="`birthOutcomeChild_${index}_still`"
                               class="fancy-input-label column no-wrapping-label">Fresh Still</label>

                        <input type="radio" v-bind:name="`birthOutcomeChild_${index}`"
                               v-bind:id="`birthOutcomeChild_${index}_macerated`"
                               v-bind:value="`birthOutcomeChild_${index}_macerated`"
                               class="fancy-input"
                               v-model="patientFeedback.surgeryInformation.childrenData[index].birthOutcome"/>
                        <label v-bind:for="`birthOutcomeChild_${index}_macerated`"
                               class="fancy-input-label column no-wrapping-label">Macerated</label>

                        <input type="radio" v-bind:name="`birthOutcomeChild_${index}`"
                               v-bind:id="`birthOutcomeChild_${index}_diedafterdelivery`"
                               v-bind:value="`birthOutcomeChild_${index}_diedafterdelivery`"
                               class="fancy-input"
                               v-model="patientFeedback.surgeryInformation.childrenData[index].birthOutcome"/>
                        <label v-bind:for="`birthOutcomeChild_${index}_diedafterdelivery`"
                               class="fancy-input-label column no-wrapping-label">Died before discharge</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full"
                     v-bind:class="{'bottom-border-input':patientFeedback.surgeryInformation.childrenData[index].birthOutcome===`birthOutcomeChild_${index}_alive`}">
                  <div class="columns is-multiline is-vcentered">


                    <div class="column has-text-left"
                         v-bind:class="{'is-half bottom-border-input-mobile':patientFeedback.surgeryInformation.childrenData[index].complication===`birthComplicationChild_${index}_birthcomplication`,
                     'is-full':patientFeedback.surgeryInformation.childrenData[index].complication!==`birthComplicationChild_${index}_birthcomplication`,
                }">
                      <label class="label has-text-centered">Birth Complication</label>
                      <div class="field is-narrow">
                        <div class="control">
                          <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered">
                            <input type="radio" v-bind:name="`birthComplicationChild_${index}`"
                                   v-bind:id="`birthComplicationChild_${index}_birthcomplication`"
                                   v-bind:value="`birthComplicationChild_${index}_birthcomplication`"
                                   class="fancy-input"
                                   v-model="patientFeedback.surgeryInformation.childrenData[index].complication"/>
                            <label v-bind:for="`birthComplicationChild_${index}_birthcomplication`"
                                   class="fancy-input-label column no-wrapping-label">Yes</label>

                            <input type="radio" v-bind:name="`birthComplicationChild_${index}`"
                                   v-bind:id="`birthComplicationChild_${index}_birthnocomplication`"
                                   v-bind:value="`birthComplicationChild_${index}_birthnocomplication`"
                                   class="fancy-input"
                                   v-model="patientFeedback.surgeryInformation.childrenData[index].complication"/>
                            <label v-bind:for="`birthComplicationChild_${index}_birthnocomplication`"
                                   class="fancy-input-label column no-wrapping-label">No</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="column is-half has-text-left left-border-input"
                         v-if="patientFeedback.surgeryInformation.childrenData[index].complication===`birthComplicationChild_${index}_birthcomplication`">
                      <label class="label has-text-centered">Complication Details</label>
                      <div class="field">
                        <p class="control is-expanded">
                      <textarea class="textarea" placeholder="Birth Complication details"
                                v-bind:ref="`birthComplications_${index}`"
                                v-bind:id="`birthComplications_${index}`"
                                v-on:keyup="resizeById(`birthComplications_${index}`)"
                                v-model="patientFeedback.surgeryInformation.childrenData[index].complicationDetails"
                      ></textarea>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>


                <div
                    class="column is-half has-text-left bottom-border-input-mobile right-border-input bottom-border-input"
                    v-if="patientFeedback.surgeryInformation.childrenData[index].birthOutcome===`birthOutcomeChild_${index}_alive`">
                  <label class="label has-text-centered">Name</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder="Child Name"
                             v-model="patientFeedback.surgeryInformation.childrenData[index].name">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'user']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-half has-text-left bottom-border-input-mobile bottom-border-input"
                     v-if="patientFeedback.surgeryInformation.childrenData[index].birthOutcome===`birthOutcomeChild_${index}_alive`">
                  <label class="label has-text-centered">Gender</label>
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-vcentered">
                        <input type="radio"
                               v-bind:name="`genderChild_${index}`"
                               v-bind:id="`genderChild_${index}_male`"
                               v-bind:value="`genderChild_${index}_male`"
                               class="fancy-input"
                               v-model="patientFeedback.surgeryInformation.childrenData[index].gender"/>
                        <label v-bind:for="`genderChild_${index}_male`"
                               class="fancy-input-label column no-wrapping-label">Male</label>
                        <input type="radio"
                               v-bind:name="`genderChild_${index}`"
                               v-bind:id="`genderChild_${index}_female`"
                               v-bind:value="`genderChild_${index}_female`"
                               class="fancy-input"
                               v-model="patientFeedback.surgeryInformation.childrenData[index].gender"/>
                        <label v-bind:for="`genderChild_${index}_female`"
                               class="fancy-input-label column no-wrapping-label">Female</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-one-third has-text-left bottom-border-input-mobile right-border-input"
                     v-if="patientFeedback.surgeryInformation.childrenData[index].birthOutcome===`birthOutcomeChild_${index}_alive`">
                  <label class="label has-text-centered">Weight (Kg)</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder="Child Weight"
                             v-model="patientFeedback.surgeryInformation.childrenData[index].weight"
                             v-on:keydown="FloatsOnly">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'weight-scale']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-one-third has-text-left bottom-border-input-mobile right-border-input"
                     v-if="patientFeedback.surgeryInformation.childrenData[index].birthOutcome===`birthOutcomeChild_${index}_alive`">
                  <label class="label has-text-centered">APGAR Score (1 Min)</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder="APGAR 1 Min"
                             v-model="patientFeedback.surgeryInformation.childrenData[index].apgar1Min"
                             v-on:keydown="IntegersOnly">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'stethoscope']"/>
                </span>
                    </p>
                  </div>
                </div>
                <div class="column is-one-third has-text-left"
                     v-if="patientFeedback.surgeryInformation.childrenData[index].birthOutcome===`birthOutcomeChild_${index}_alive`">
                  <label class="label has-text-centered">APGAR Score (5 Min)</label>
                  <div class="field">
                    <p class="control is-expanded has-icons-left">
                      <input class="input input-no-top-margin" type="text" placeholder="APGAR 5 Min"
                             v-model="patientFeedback.surgeryInformation.childrenData[index].apgar5Min"
                             v-on:keydown="IntegersOnly">
                      <span class="icon is-small is-left">
                  <font-awesome-icon :icon="['fas', 'stethoscope']"/>
                </span>
                    </p>
                  </div>
                </div>

                <div class="column is-full"></div>
              </div>
            </div>

            <div class="column is-full" v-if="showChildrenSection && surgeryHappened"></div>

            <div class="column is-full" v-if="surgeryHappened"></div>
            <div class="column is-full" v-if="surgeryHappened">
              <div id="personalQuote" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Patient Story (Post-OP)</div>
                </div>
                <div class="column is-full input-no-padding-top">
                  <div class="field">
                    <p class="has-text-justified">How will the surgical outcome impact the patient’s life? If the
                      treatment was not a success, please describe what happened, and let us know if there are any next
                      steps.</p>
                    <p class="control is-expanded">
                      <textarea class="textarea" placeholder="Personal Story"
                                v-on:keyup="resize('personalStoryTextarea')" ref="personalStoryTextarea"
                                v-bind:class="{'error-input':v$.patientFeedback.surgeryInformation.patientStory.$errors.length>0 && showErrors[0]}"
                                v-model.trim="patientFeedback.surgeryInformation.patientStory"></textarea>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-full" v-if="surgeryHappened"></div>

            <div class="column is-full" v-if="surgeryHappened">
              <div id="personalQuote" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Personal Quote (Post-OP)</div>
                </div>
                <div class="column is-full input-no-padding-top">
                  <div class="field">
                    <p class="has-text-justified">Share a positive quote from the patient. How their experience in the
                      hospital was, and what are
                      they looking forward to after recovery?</p>
                    <p class="control is-expanded">
                      <textarea class="textarea" placeholder="Personal Quote"
                                v-on:keyup="resize('personalQuoteTextarea')" ref="personalQuoteTextarea"
                                v-bind:class="{'error-input':v$.patientFeedback.surgeryInformation.patientQuote.$errors.length>0 && showErrors[0]}"
                                v-model.trim="patientFeedback.surgeryInformation.patientQuote"></textarea>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="column is-full"></div>

            <div class="column is-full" v-if="displayErrorsForTab('Surgery Tab').length">
              <div id="AttachmentsSeven"
                   class="columns is-multiline is-vcentered section-box section-box-errors">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text section-box-title-text-error">Surgery Tab Errors & Notices</div>
                </div>
                <div class="column is-full">
                  <p class="has-text-left"
                     v-for="error of displayErrorsForTab('Surgery Tab')"
                     :key="error.uid"
                  ><strong class="strong-text-error">{{ error.message }}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-full" v-if="displayErrorsForTab('Surgery Tab').length"></div>

          </div>
        </div>
      </TabContent>
      <TabContent title="Attachments" icon="fa fa-paperclip">
        <div class="container">
          <div class="columns is-multiline is-mobile is-vcentered">

            <div class="column is-full" v-if="surgeryHappened">
              <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
            </div>

            <div class="column is-full" v-if="surgeryHappened">
              <div id="AttachmentsOne" class="columns is-multiline is-mobile is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Note</div>
                </div>
                <div class="column is-full">
                  <p class="is-size-5 has-text-justified">The photo must show the patient’s face and be as positive
                    and
                    dignified as
                    possible, Solid backgrounds (such as a painted wall) with natural light are best. If possible,
                    please
                    send multiple photos and we will select the best one.</p>
                </div>
              </div>
            </div>

            <div class="column is-full" v-if="surgeryHappened"></div>
            <div class="column is-full" v-if="surgeryHappened">
              <div id="AttachmentsTwo" class="columns is-multiline is-mobile is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Post-OP Photos</div>
                </div>
                <div class="column is-half"
                     v-bind:class="{'error-input':v$.patientFeedback.confirmation.faceOne.$errors.length>0 && showErrors[1]}"
                >
                  <dropZone2Component
                      v-bind:id="`faceOne`"
                      v-bind:key="`faceOne`"
                      v-bind:fileIdentifier="`faceOne`"
                      v-bind:formName="`feedback`"
                      v-bind:zoneTitle="'Image'"
                      v-bind:dataTs="patientFeedback.profileTS"
                      v-bind:imageDataObj="patientFeedback.confirmation.faceOne"
                      v-bind:acceptedFiles="'.jpg,.jpeg,.png'"
                      v-bind:inputsDisabled="false"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div class="column is-half"
                     v-bind:class="{'error-input':v$.patientFeedback.confirmation.faceTwo.$errors.length>0 && showErrors[1]}"
                >
                  <dropZone2Component
                      v-bind:id="`faceTwo`"
                      v-bind:key="`faceTwo`"
                      v-bind:fileIdentifier="`faceTwo`"
                      v-bind:formName="`feedback`"
                      v-bind:zoneTitle="'Image'"
                      v-bind:dataTs="patientFeedback.profileTS"
                      v-bind:imageDataObj="patientFeedback.confirmation.faceTwo"
                      v-bind:acceptedFiles="'.jpg,.jpeg,.png'"
                      v-bind:inputsDisabled="false"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
              </div>
            </div>

            <div class="column is-full" v-if="surgeryHappened"></div>
            <div class="column is-full" v-if="surgeryHappened">
              <div id="AttachmentsThree" class="columns is-multiline is-mobile is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Condition</div>
                </div>
                <div class="column is-half">
                  <dropZone2Component
                      v-bind:id="`conditionOne`"
                      v-bind:key="`conditionOne`"
                      v-bind:fileIdentifier="`conditionOne`"
                      v-bind:formName="`feedback`"
                      v-bind:zoneTitle="'Condition'"
                      v-bind:dataTs="patientFeedback.profileTS"
                      v-bind:imageDataObj="patientFeedback.confirmation.conditionOne"
                      v-bind:acceptedFiles="'.jpg,.jpeg,.png'"
                      v-bind:inputsDisabled="false"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div class="column is-half">
                  <dropZone2Component
                      v-bind:id="`conditionTwo`"
                      v-bind:key="`conditionTwo`"
                      v-bind:fileIdentifier="`conditionTwo`"
                      v-bind:formName="`feedback`"
                      v-bind:zoneTitle="'Condition'"
                      v-bind:dataTs="patientFeedback.profileTS"
                      v-bind:imageDataObj="patientFeedback.confirmation.conditionTwo"
                      v-bind:acceptedFiles="'.jpg,.jpeg,.png'"
                      v-bind:inputsDisabled="false"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
              </div>
            </div>


            <div class="column is-full" v-if="surgeryHappened"></div>
            <div class="column is-full" v-if="surgeryHappened">
              <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Additional Attachments</div>
                </div>
                <div class="column is-one-quarter"
                     v-bind:class="{'error-input':v$.patientFeedback.confirmation.safeScaleReport.$errors.length>0 && showErrors[1]}">
                  <dropZone2Component
                      v-bind:id="`safeScaleReport`"
                      v-bind:key="`safeScaleReport`"
                      v-bind:fileIdentifier="`safeScaleReport`"
                      v-bind:formName="`feedback`"
                      v-bind:zoneTitle="'Surgical Outcome Document'"
                      v-bind:dataTs="patientFeedback.profileTS"
                      v-bind:imageDataObj="patientFeedback.confirmation.safeScaleReport"
                      v-bind:acceptedFiles="'.pdf,.jpg,.jpeg,.png'"
                      v-bind:inputsDisabled="false"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div v-if="patientFeedback.profileTS" class="column is-one-quarter">
                  <dropZone2Component
                      v-bind:id="`feedbackAttachment_1`"
                      v-bind:key="`feedbackAttachment_1`"
                      v-bind:fileIdentifier="`feedbackAttachment_1`"
                      v-bind:formName="`feedback`"
                      v-bind:zoneTitle="'Attachment 1'"
                      v-bind:dataTs="patientFeedback.profileTS"
                      v-bind:imageDataObj="patientFeedback.confirmation.feedbackAttachment_1"
                      v-bind:acceptedFiles="'.pdf,.jpg,.jpeg,.png'"
                      v-bind:inputsDisabled="false"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div v-if="patientFeedback.profileTS" class="column is-one-quarter">
                  <dropZone2Component
                      v-bind:id="`feedbackAttachment_2`"
                      v-bind:key="`feedbackAttachment_2`"
                      v-bind:fileIdentifier="`feedbackAttachment_2`"
                      v-bind:formName="`feedback`"
                      v-bind:zoneTitle="'Attachment 2'"
                      v-bind:dataTs="patientFeedback.profileTS"
                      v-bind:imageDataObj="patientFeedback.confirmation.feedbackAttachment_2"
                      v-bind:acceptedFiles="'.pdf,.jpg,.jpeg,.png'"
                      v-bind:inputsDisabled="false"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
                <div v-if="patientFeedback.profileTS" class="column is-one-quarter">
                  <dropZone2Component
                      v-bind:id="`feedbackAttachment_3`"
                      v-bind:key="`feedbackAttachment_3`"
                      v-bind:fileIdentifier="`feedbackAttachment_3`"
                      v-bind:formName="`feedback`"
                      v-bind:zoneTitle="'Attachment 3'"
                      v-bind:dataTs="patientFeedback.profileTS"
                      v-bind:imageDataObj="patientFeedback.confirmation.feedbackAttachment_3"
                      v-bind:acceptedFiles="'.pdf,.jpg,.jpeg,.png'"
                      v-bind:inputsDisabled="false"
                      v-on:dropZone2Emissions="dropZone2Emissions"
                  ></dropZone2Component>
                </div>
              </div>
            </div>


            <div class="column is-full"></div>
            <div class="column is-full">
              <div id="AttachmentsSeven" class="columns is-multiline is-mobile is-vcentered section-box">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text">Acknowledgement</div>
                </div>
                <div class="column is-full has-text-left label-no-padding-bottom">
                  <label class="label has-text-left">By submitting this form, you acknowledge that all of the
                    information contained in
                    this document is true to the best of
                    your knowledge. If at any point the information contained above becomes inaccurate, you agree to
                    notify
                    the SAFE Program as soon
                    as possible.</label>
                </div>
                <div class="column is-full"
                     v-bind:class="{'error-input':v$.patientFeedback.confirmation.signedAcknowledgement.$errors.length>0 && showErrors[1]}"
                >
                  <div class="field is-narrow">
                    <div class="control">
                      <div class="fancy-input-group padded-checkboxes columns is-multiline is-mobile is-vcentered">
                        <input type="radio" name="signedAcknowledgement" id="signedAcknowledgementyes"
                               value="signedAcknowledgementyes" class="fancy-input"
                               v-model="patientFeedback.confirmation.signedAcknowledgement"/>
                        <label for="signedAcknowledgementyes"
                               class="fancy-input-label column no-wrapping-label">Yes</label>
                        <input type="radio" name="signedAcknowledgement" id="signedAcknowledgementno"
                               value="signedAcknowledgementno" class="fancy-input"
                               v-model="patientFeedback.confirmation.signedAcknowledgement"/>
                        <label for="signedAcknowledgementno"
                               class="fancy-input-label column no-wrapping-label">No</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
              </div>

            </div>

            <div class="column is-full"></div>
            <div class="column is-full" v-if="v$.$errors.length">
              <div id="AttachmentsSeven"
                   class="columns is-multiline is-vcentered section-box section-box-errors">
                <div class="column is-full section-box-title-column">
                  <div class="section-box-title-text section-box-title-text-error">All Errors & Notices</div>
                </div>
                <div class="column is-full">
                  <p class="has-text-left"
                     v-for="error of v$.$errors"
                     :key="error.$uid"
                  ><strong class="strong-text-error">{{ error.$message }}</strong>
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-full" v-if="v$.$errors.length"></div>
          </div>
        </div>
      </TabContent>
      <TabContent title="Summary" icon="fa fa-clipboard-list">
        <div v-if="summaryAvailableBool && validationHasOccured" ref="summaryData">
          <div class="container">
            <div class="container">
              <div class="columns is-multiline is-vcentered">
                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Profile {{ profileID }}</h1>
                </div>
                <div class="column is-full">
                  <div id="surgeryOne" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Profile Data</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Full Name</label>
                            <div class="has-text-centered">{{ activeProfile.patientName }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Patient Hospital Number</label>
                            <div class="has-text-centered">{{ activeProfile.inpatientNumber }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Gender</label>
                            <div class="has-text-centered">{{ activeProfile.patientGender }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3">
                            <label class="label has-text-left">Date of Birth</label>
                            <div class="has-text-centered">{{ activeProfile.patientDob }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="2">
                            <label class="label has-text-left">Type</label>
                            <div class="has-text-centered">{{ activeProfile.surgeryType }}</div>
                          </td>
                          <td class="middle-table-cell" colspan="2">
                            <label class="label has-text-left">Surgery required</label>
                            <div class="has-text-centered">{{ activeProfile.surgeryRequired }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="2">
                            <label class="label has-text-left">Estimated Date of Surgery</label>
                            <div class="has-text-centered">{{ activeProfile.estimatedSurgeryDay }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="columns is-multiline is-vcentered">
                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Surgery</h1>
                </div>
                <div class="column is-full">
                  <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Surgery Data</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Status</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.surgeryStatus }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3"
                              v-if="returnSummaryFeedbackData.surgeryStatus==='Done'">
                            <label class="label has-text-left">Actual Surgery</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.actualSurgery }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="3" v-else>
                            <label class="label has-text-left">Reason</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.surgeryStatusReason }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="2">
                            <label class="label has-text-left">Admission</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.admissionData }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="2">
                            <label class="label has-text-left">Surgery</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.surgeryData }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="2">
                            <label class="label has-text-left">Discharge</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.dischargeData }}</div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">Final Bill</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.finalBill }}</div>
                          </td>
                          <td class="middle-table-cell" colspan="3">
                            <label class="label has-text-left">Co-payment</label>
                            <div class="has-text-centered" v-html="returnSummaryFeedbackData.coPaymentDisplay"></div>
                          </td>
                        </tr>
                        <tr>
                          <td class="left-side-table-cell" colspan="3">
                            <label class="label has-text-left">SAFE-Score Rating</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.safeScoreRating }}</div>
                          </td>
                          <td class="middle-table-cell" colspan="3">
                            <label class="label has-text-left">SAFE-Score Comment</label>
                            <div class="has-text-centered" v-html="returnSummaryFeedbackData.safeScoreComment"></div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container" v-if="returnSummaryFeedbackData.isBirthSurgery==='YES'">
              <div class="columns is-multiline is-vcentered">
                <div class="column is-full">
                  <h1 class="is-size-3">&nbsp;</h1>
                </div>
                <div class="column is-full">
                  <div id="surgeryBirth" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Birth Outcome</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td class="left-side-table-cell" colspan="2">
                            <label class="label has-text-left">Gravidity</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.birthOutcomeGravidity }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="2">
                            <label class="label has-text-left">Parity</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.birthOutcomeParity }}</div>
                          </td>
                          <td class="right-side-table-cell" colspan="2">
                            <label class="label has-text-left">Births</label>
                            <div class="has-text-centered">{{
                                returnSummaryFeedbackData.birthOutcomeChildrenCount
                              }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="6">
                            <div class="columns is-multiline is-vcentered">
                              <div class="column is-full"></div>
                              <div v-for="(child, index) in returnSummaryFeedbackData.childrenFormated"
                                   class="column is-half has-text-centered" v-bind:key="index"
                                   v-html="child"></div>
                              <div class="column is-full"></div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="columns is-multiline is-vcentered">
                <div class="column is-full">
                  <h1 class="is-size-3">&nbsp;</h1>
                </div>
                <div class="column is-full">
                  <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Patient Story</div>
                    </div>
                    <div class="column is-full" v-html="returnSummaryFeedbackData.patientStory"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="columns is-multiline is-vcentered">
                <div class="column is-full">
                  <h1 class="is-size-3">&nbsp;</h1>
                </div>
                <div class="column is-full">
                  <div id="surgeryData" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Patient Quote</div>
                    </div>
                    <div class="column is-full" v-html="returnSummaryFeedbackData.patientQuote"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="columns is-multiline">

                <div class="column is-full">
                  <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
                </div>

                <div class="column is-full" v-if="returnSummaryFeedbackData.faceImages.length!==0">
                  <div id="AttachmentsTwo" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Post-OP Photos</div>
                    </div>
                    <div class="column is-half input-no-padding-top"
                         v-for="(faceImage, index) in returnSummaryFeedbackData.faceImages"
                         v-bind:key="index">
                      <div class="image-relative-container">
                        <div class="image-flex-container">
                          <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face"
                               class="image" v-if="faceImage.thumbnail">
                        </div>
                        <div class="image-flex-container" v-if="faceImage.timestamp">Timestamp:
                          <span>{{ faceImage.timestamp }}</span>
                        </div>
                        <div>Location:
                          <a v-bind:href="faceImage.location" target="_blank"
                             v-if="faceImage.location!==''">Here</a>
                          <span v-else></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full" v-if="returnSummaryFeedbackData.conditionImages.length!==0"></div>
                <div class="column is-full" v-if="returnSummaryFeedbackData.conditionImages.length!==0">
                  <div id="AttachmentsThree" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Condition</div>
                    </div>
                    <div class="column is-half input-no-padding-top"
                         v-for="(conditionImage, index) in returnSummaryFeedbackData.conditionImages"
                         v-bind:key="index">
                      <div class="image-relative-container">
                        <div class="image-flex-container">
                          <img v-bind:src="`${conditionImage.thumbnail}`" alt="Condition Image"
                               class="image"
                               v-if="conditionImage.thumbnail">
                        </div>
                        <div class="image-flex-container" v-if="conditionImage.timestamp">Timestamp: <span>{{
                            conditionImage.timestamp
                          }}</span></div>
                        <div>Location:
                          <a v-bind:href="conditionImage.location" target="_blank"
                             v-if="conditionImage.location!==''">Here</a>
                          <span v-else></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Additional Attachments</div>
                    </div>
                    <div class="column is-one-quarter">
                      <div class="image-relative-container"
                           v-if="returnSummaryFeedbackData.safeScaleReportImages.length>0">
                        <div class="image-flex-container">
                          <img v-bind:src="`${returnSummaryFeedbackData.safeScaleReportImages[0].thumbnail}`"
                               alt="Surgical Outcome Document"
                               class="image">
                        </div>
                      </div>
                    </div>
                    <div class="column is-one-quarter"
                         v-for="(additionalAttachment, index) in returnSummaryFeedbackData.additionalAttachments"
                         v-bind:key="index">
                      <div class="image-relative-container">
                        <div class="image-flex-container">
                          <img v-bind:src="`${additionalAttachment.thumbnail}`"
                               alt="Additional Attachment"
                               class="image" v-if="additionalAttachment.thumbnail">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="column is-full"></div>
                <div class="column is-full">
                  <div id="AttachmentsSeven" class="columns is-multiline is-vcentered section-box">
                    <div class="column is-full section-box-title-column">
                      <div class="section-box-title-text">Acknowledgement</div>
                    </div>
                    <div class="column is-full can-scroll-content">
                      <table class="table is-striped is-fullwidth">
                        <tbody>
                        <tr>
                          <td>
                            <label class="label has-text-left">By submitting this form, you acknowledge that all of the
                              information contained in this document is true to the best of your knowledge. If at any
                              point the information contained above becomes inaccurate, you agree to notify the SAFE
                              Program as soon as possible.</label>
                            <div class="has-text-centered">{{ returnSummaryFeedbackData.signedAcknowledgement }}</div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="column is-full"></div>

              </div>
            </div>
          </div>
        </div>
        <div class="container" v-if="!summaryAvailableBool && validationHasOccured">
          Please complete all form to view the summary
        </div>
      </TabContent>
    </FormWizard>
  </div>
  <div class="profile-form-container center-screen" v-if="feedbackSubmitted">
    <div class="columns is-multiline is-vcentered">
      <div class="column is-full">
        <a href="#" target="_blank" class="thumb fa fa-thumbs-up"></a>
        <div class="circle-wrap">
          <div class="circle-lg"></div>
        </div>
        <div class="dots-wrap">
          <div class="dot dot--t"></div>
          <div class="dot dot--tr"></div>
          <div class="dot dot--br"></div>
          <div class="dot dot--b"></div>
          <div class="dot dot--bl"></div>
          <div class="dot dot--tl"></div>
        </div>
      </div>
      <div class="column is-full" v-html="feedbackSubmittedMsg" style="margin-top: 60px"></div>
      <div class="column is-full">
        <button class='button is-fullwidth' v-on:click="closeFeedbackForm">OK</button>
      </div>
    </div>
  </div>
</template>

<style>
@import "@/assets/fontawesome-free-6.5.2-web/css/all.min.css";

[v-cloak] {
  display: none;
}

.black-border {
  border: 2px solid black !important;
}

.left-side-table-cell {
  border-right: 1px solid hsl(0, 0%, 86%) !important;
}

.right-side-table-cell {
  border-left: 1px solid hsl(0, 0%, 86%) !important;
}

.middle-table-cell {
  border-right: 1px solid hsl(0, 0%, 86%) !important;
  border-left: 1px solid hsl(0, 0%, 86%) !important;
}

.error-input {
  border: 1px solid red !important;
  background-color: #ffefef !important;
  opacity: 0.9 !important;
}

.section-box {
  border: 1px solid black;
  padding: 5px;
  border-radius: 10px;
}

.section-box-errors {
  border-color: red !important;
}

.section-box-title-column {
  position: relative;
  top: -18px;
  padding: 0 !important;
  margin: 0 !important;
}

.section-box-title-text {
  background-color: white;
  padding: 0 5px;
  width: max-content;
  margin: 0 10px;
  border-radius: 5px;
}

.section-box-title-text-error {
  color: red !important;
}

.strong-text-error {
  color: red !important;
}

.wrapper-custom > div, .wrapper-custom > div > div#calendar-div {
  width: 100%;
}

.wrapper-custom div.vuejs3-datepicker__value {
  border: none;
  width: 100%;
  padding: 7px 0 0 0;
}

.wrapper-custom span.vuejs3-datepicker__clear-button {
  top: 7px;
}

.input-no-top-margin {
  margin-top: 0 !important;
}

.label-no-padding-bottom {
  padding-bottom: 0 !important;
}

.input-no-padding-top {
  padding-top: 0 !important;
}

.input-no-margin-top {
  margin-top: 0 !important;
}

.no-wrapping-label {
  white-space: nowrap;
}

.profile-form-container {
  padding: 20px;
}

.center-screen {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -250px;
  width: 500px;
  height: 100px;
}

.highlighted-text {
  font-weight: bold;
  font-size: xx-large;
}

.surgery-date-time {
  border-right: 1px solid black;
  border-left: 1px solid black;
}

@media screen and (max-width: 768px) {
  .surgery-date-time {
    border-right: none;
    border-left: none;
  }

  .right-border-input {
    border-right: none;
  }

  .left-border-input {
    border-left: none;
  }

  .bottom-border-input-mobile {
    border-bottom: 1px solid black;
  }
}

@media screen and (min-width: 769px) {
  .bottom-border-input-mobile {
    border-bottom: none;
  }

  .right-border-input {
    border-right: 1px solid black;
  }

  .left-border-input {
    border-left: 1px solid black;
  }
}

.child-box {
  margin-bottom: 40px !important;
}

.can-scroll-content {
  overflow-x: scroll;
}

.bottom-border-input {
  border-bottom: 1px solid black;
}

.top-border-input {
  border-top: 1px solid black;
}

.padded-checkboxes {
  padding: 12px;
}

</style>
